import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/erkend-goed-doel.png")